import { chakra, Heading, useBreakpointValue } from '@chakra-ui/react';
import React, { ReactNode, useContext } from 'react';
import { HeroTextContentContext } from './HeroTextContent';

type HeroTitleProps = {
  title: ReactNode | string;
  mobileTitle?: ReactNode;
  className?: string;
  size?: string;
};

/**
 * Hero Title component
 */
export default chakra(function HeroTitle_({
  title,
  mobileTitle,
  className,
  size,
}: HeroTitleProps) {

  const { center } = useContext(HeroTextContentContext);
  const newMobileTitle = mobileTitle || title
  const isMobileTitleString = typeof newMobileTitle === 'string'
  const isTitleString = typeof title === 'string'
  const showDesktop = useBreakpointValue({base: false, lg: true});

  const renderTitle = showDesktop ? title : newMobileTitle;
  const titleString = showDesktop ? isTitleString : isMobileTitleString;

  return (
    <Heading
      className={className}
      size={size ?? 'h1'}
      fontSize='52px'
      lineHeight='64px'
      letterSpacing='-1.5px'
      as='h1'
      textAlign={{ lg: center ? 'center' : 'left', base: 'center' }}
    >
      {titleString ? <div dangerouslySetInnerHTML={{__html: renderTitle as string}} /> : renderTitle}
    </Heading>
  );
});
